









import Vue from 'vue';
import CoverLetterForm, {
  FormDataInterface,
} from '@/containers/cover-letters/form.vue';
import * as CoverLettersStore from '@/containers/cover-letters/store';
import { i18n, i18nHints } from '@/plugins/i18n';

export default Vue.extend({
  components: {
    CoverLetterForm,
  },
  methods: {
    async onSubmit({ title, content }: FormDataInterface) {
      await this.$store.dispatch(
        CoverLettersStore.CreateCoverLetter.namespaced({
          body: { title, content },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.created));
      this.$router.push({ name: 'cvs_path' });
    },
    onCancel() {
      this.$backOrGoTo({ name: 'cvs_path' });
    },
  },
});
